import styled from 'styled-components'

export const Style = styled.div`
  margin: 55px 0;
  .col-vendor {
    margin-bottom: 60px;
  }
  .card-long-box {
    padding-top: 30px;
    padding-bottom: 30px;
  }
  @media screen and (min-width: 300px) and (max-width: 1116px) {
    margin: 0;
    .card-long-box {
      display: flex;
      justify-content: space-between;
      padding: 0;
      margin-bottom: 15px;
    }
    .text {
      width: calc(100% - 70px);
      h4,
      p {
        text-align: left;
      }
    }
    .card-long-image {
    }
    .image-top {
      display: none;
    }
  }
  .col-vendor {
    margin-bottom: 0;
  }
  .image-auto {
    width: 100%;
    display: block;
  }
  .bottom-margin {
    margin-bottom: 20px;
  }
  .auto-margin {
    margin-top: 20px;
    margin: 0 auto;
  }
  .auto-display {
    margin-bottom: 40px;
    display: flex;
    justify-content: flex-start;
  }
`
